import Vue from 'vue';
import moment from 'moment';
import table from '../../components/ins-manage/ins-table.vue';
import withdrawDialog from './dlg-apply-withdraw.vue';
import { formChannelOptions } from './ins-utils.ts';
export default Vue.extend({
    components: {
        'el-balance-list': table,
        'el-withdraw-dlg': withdrawDialog,
    },
    data: function () {
        var _this = this;
        return {
            dialogWithDrawVisiable: false,
            withdrawInfo: {
                channelName: '',
                endTime: '',
            },
            requestConfig: {
                url: '/proxy/carInsurance/channelBill/queryStatementList',
                method: 'post',
            },
            mutexDisableParam: {
                closeMutex: true,
            },
            searchConfig: [
                {
                    label: '开票渠道',
                    type: 'select',
                    key: 'channelId',
                    labelWidth: '80px',
                    option: [],
                },
                {
                    label: '生成日期',
                    key: 'createdAtStart',
                    type: 'dateRange',
                    startTimeKey: 'createdAtStart',
                    endTimeKey: 'createdAtEnd',
                    clearable: false,
                },
                {
                    label: '对账单编号',
                    key: 'statementNo',
                    type: 'input',
                    clearable: true,
                    placeholder: '请输入对账单编号',
                },
            ],
            tableConfig: [
                {
                    label: '对账单编号',
                    prop: 'statementNo',
                    tooltip: true,
                    width: '220px',
                },
                {
                    label: '生成日期',
                    prop: 'createdAt',
                    tooltip: true,
                    width: '186px',
                },
                {
                    label: '账单截止日期',
                    prop: 'endTime',
                    tooltip: true,
                    width: '128px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '开票渠道',
                    prop: 'channelName',
                    width: '185px',
                },
                {
                    label: '费用条数',
                    prop: 'sumBillNumber',
                    width: '100px',
                },
                {
                    label: '总保费',
                    prop: 'sumOrderAmount',
                    width: '120px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '待结推广费',
                    prop: 'sumAmount',
                    width: '120px',
                    formatter: function (val) {
                        return val;
                    },
                },
                {
                    label: '状态',
                    prop: 'isDisabled',
                    width: '120px',
                    formatter: function (val) {
                        if (val === 1) {
                            return '已撤回';
                        }
                        else {
                            return '正常';
                        }
                    },
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    minWidth: '120px',
                    fixed: 'right',
                    btns: [
                        {
                            name: '查看',
                            formatter: function (row) {
                                var isDisabled = row.isDisabled;
                                if (isDisabled === 1) {
                                    return false;
                                }
                                return true;
                            },
                            callback: function (row) {
                                _this.detail(row);
                            },
                        },
                        {
                            name: '撤回',
                            formatter: function (row) {
                                var isDisabled = row.isDisabled;
                                if (isDisabled === 1) {
                                    return false;
                                }
                                return true;
                            },
                            callback: function (row) {
                                _this.deleteC(row);
                            },
                        },
                    ],
                },
            ],
        };
    },
    methods: {
        show: function () {
            this.dialogWithDrawVisiable = true;
        },
        shut: function () {
            this.dialogWithDrawVisiable = false;
        },
        onWithdrawDone: function () {
            this.$refs.balanceList.filterBefore();
        },
        detail: function (row) {
            this.$router.push({
                name: 'insBalanceCheckDetail',
                params: { checkOrderId: row.id.toString() },
            });
        },
        deleteC: function (row) {
            this.withdrawInfo = {
                channelName: row.saleChannel.channelName,
                endTime: moment(row.endTime).format('YYYY-MM-DD'),
                statementId: row.id,
            };
            this.show();
        },
    },
    created: function () {
        var _this = this;
        formChannelOptions().then(function (res) {
            _this.searchConfig[0].option = res;
        });
    },
});
